export default __webpack_public_path__ + "static/media/informacionw.8dc80d09.svg";